import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { WidgetLoginAuthO as WidgetLogin2 } from '@nationgroup/nation-login-widgets';
import Cookies from 'js-cookie';
import _ from 'lodash';
import { useRouter } from 'next/router';
import { APP_URL, NEXT_PUBLIC_LOGIN_STATE_DATE } from 'src/constants';
import CheckboxForm from 'src/services/member-auth/components/forms/checkbox-form';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

function WidgetLogin ({ sessionSevId, email, image, phoneNumber, pathname, isOpen, showSpecial }) {
  const router = useRouter();
  const [open, setOpen] = useState(isOpen);
  const [error, setError] = useState('');
  const [checkPDPA, setCheckPDPA] = useState(false);
  const [checkCookies, setCheckCookies] = useState(false);

  const conditionDisabled = Cookies.get('login') === 'success' ? false : !(checkPDPA && checkCookies);
  const nid = Cookies.get('_nid');
  const ga = Cookies.get('_ga');
  const _key = nid ? `${ga} : ${nid}` : `${ga}`;
  // console.log(sessionSevId, email);
  // useEffect( async () => {
  //   if(!_.isEmpty(sessionSevId)) {
  //     await new Promise((e) => setTimeout(e, 0));
  //     const getElementsRemoveSvg = document.querySelectorAll('.btn-login > svg');
  //     if (getElementsRemoveSvg) {
  //       getElementsRemoveSvg?.[0]?.setAttribute("class", "table-info");
  //         console.log({ getElementsRemoveSvg });

  //     }
  //   }
  // }, []);
  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <WidgetWrapper id='widget-login' check={!_.isEmpty(sessionSevId)}>
      <DisplayLogin >
        <div className='bg'>
          {!_.isEmpty(sessionSevId) &&
            <div className='news-image'>
              <img className='login' width={30} height={30} src={image} />
            </div>
          }
          <div className='group-data'>
            <WidgetLogin2
              className='widget-login'
              sendDataLayerGlobal={sendDataLayerGlobal}
              DATALAYER_TYPE={DATALAYER_TYPE}
              conditionDisabled={conditionDisabled}
              error={error}
              sessionSevId={ !_.isEmpty(sessionSevId) ? { ...sessionSevId, image: image } : sessionSevId}
              open={open}
              setOpen={setOpen}
              setError={setError}
              router={router}
              _key={_key}
              nextAuthUrl={APP_URL}
              redirectUrl={pathname ?? '/'}
              isRemoveCookie={true}
              loginStateExpire={Number(NEXT_PUBLIC_LOGIN_STATE_DATE)}
            >
            <CheckboxForm name='pdpaConsent' label={'นโยบายคุ้มครองข้อมูลส่วนบุคคล'} checked={checkPDPA} onChange={e => setCheckPDPA(e.target.checked)} />
            <CheckboxForm name='cookieConsent' label={'นโยบายคุ้มครองข้อมูลการใช้คุกกี้'} checked={checkCookies} onChange={e => setCheckCookies(e.target.checked)} />

          </WidgetLogin2>
          {/* <a href={!_.isEmpty(sessionSevId) ? '/member/profile' : '/'} rel='noopener noreferrer' target='_blank' alt='Member Profile'> */}
            {_.isEmpty(sessionSevId)
              ? <div className='info-login' onClick={() => setOpen(true)}>  เข้าสู่ระบบ  </div>

              : <div className='info'>
              <div className='text-login'> {email}</div>
              {/* {!_.isEmpty(phoneNumber) && <div className='text-login'> {phoneNumber}</div>} */}
            </div>
            }
            {/* </a> */}
          </div>
            </div>
      </DisplayLogin>
     {showSpecial === 'Y' && <BottonSpecial>
       <a href='/special-vote' rel='noopener noreferrer' target='_blank' alt='special' >
        <div className='bg'>
            SPECIAL VOTE
        </div>
       </a>
   </BottonSpecial>}

   </WidgetWrapper>
  );
}

const WidgetWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  position: relative;
  padding: 5px 30px;
  font-size: 28px;
  /* top: 15px; */
  /* padding-top: 2rem; */
  /* right: -15px; */
  z-index: 5;
  @media (max-width: 76px) {
    justify-content: space-between;

       width: 100%;

     }
  /* @media (max-width: 768px) {
    
    top: 15px;
    left: 50%;
    transform: translate(-50%, 0%);
  }   */
  .group-data {
    display: flex;
    @media (max-width: 768px) {
       
       width: 100%;

     }
  }
  .news-image {
    position: absolute;
 
    img.login {
      border-radius: 50%;

    }
  }
  .image {
    position: absolute;
    img {
      border-radius: 50%;
    }
  }
  #widget-social .modal-social .btn-social.icon-facebook {
      display: none !important;
    }
  #widget-login {
    position: relative;
    padding: 0 10px 0 0;
    align-items: center;
    display: flex;

  
  &:hover {
    .menu-list {
      filter: ${props => (props?.gray ? 'grayscale(1)' : '')};
      display: flex;
    }
    .btn-login {
      svg {
        color: #696969;
      }
    }
  }
  .link-policy {
    font-size: 14px;
    display: flex;
    justify-content: flex-end;
    color: #bfbfbf;
    &:hover {
      color: #696969;
    }
  }
 
  /* ------------------------------ BUTTON LOGIN ------------------------------ */
  .btn-login {
    width: 30px;
    height: 30px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    /* padding: 8px; */
    border: none;
    border-radius: 50px;
    &.login {
      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.08)) drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));
    }
    

    svg {
      opacity: ${props => props.check ? 0 : 1};
      width: 15px;
      height: 15px;
      filter: ${props => (props.gray ? 'grayscale(1)' : '')};
      color:  rgb(130,137,158);
      margin-bottom: 5px;
      @media (max-width: 1080px) {
        color: #fff;
      }
      @media (max-width: 690px) {
        height: 24px;
        width: 24px;
      }
      @media (max-width: 380px) {
        height: 22px;
        width: 22px;
      }
    }
    .image-user {
      filter: ${props => (props.gray ? 'grayscale(1)' : '')};
      overflow: hidden;
      margin: 0px;
      padding: 0px;
      border-radius: 50%;
      object-fit: cover;
      width: 30px;
      height: 30px;
    }
  }

  .info {
    color: rgba(230,187,127,0.92);
    font-size: 12px;
    font-weight: 300;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    .username,
    .email {
      width: 150px;
      font-size: 14px;
      font-weight: 400;
      text-transform: capitalize;

      padding: 5px;
      margin: 0;
    }
  }
  .error-label {
    font-size: 12px;
    color: red;
  }
  .menu-list {
    z-index: 30;
    display: none;
    position: absolute;
    top: 40px;
    left: 0;
    background-color: #ffffff;
    box-shadow: 1px 0px 10px 0px rgba(46, 46, 46, 0.3);
    width: max-content;
    flex-direction: column;
    border-radius: 5px;
    margin: 0;
    padding: 10px !important;
   
    a {
      text-decoration: none;
    }
    
    &:before {
      content: '';
      position: absolute;
      top: -8px;
      left: 0px;
      width: 0;
      height: 0;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      border-bottom: 15px solid white;
    }
    @media (max-width: 1080px) {
      left: auto;
      left: 0;
      top: 47px;
      &:before {
        top: -5px;
        left: 10px;
        left: auto;
      }
    }
    @media (max-width: 768px) {
      left: 0;
      top: 47px;
    }
    .list-item {
      width: 100%;
      margin: 0;
      a {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        svg {
          margin-right: 5px;
        }
      }
      &:nth-child(2) {
        display: none;
      }
    }

    svg {
      color: #A20202;
      font-weight: 700;
      margin-left: 5px;
      margin-bottom: 2px;
      transition: all 3ms ease-in;
    }
    li {
      cursor: pointer;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
      margin: 0;
      padding: 8px;
      gap: 5px;
      z-index: 2;
      border-radius: 5px;
      p {
        padding: 0;
        margin: 0;
        color: #A20202;
      }
      &:hover {
        box-shadow: 1px 0px 10px 0px rgba(2, 63, 135, 0.3);
        background-color: #A20202;
        p,
        svg {
          color: #fff;
        }
      }
    }
  }
  }
  #widget-social {
    filter: ${props => (props?.gray ? 'grayscale(1)' : '')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: rgb(0, 0, 0, 0.5);
  z-index: 15;
  .modal-social {
    background: linear-gradient(103.43deg, #f6f6f6 0%, #eeeeee 100%);
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.85);
    border-radius: 10px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    width: 320px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    gap: 14px;
    padding: 40px 30px;
    @media (max-width: 767px) {
      padding: 20px;
      width: 320px;
    }
    @media (max-width: 380px) {
      width: 300px;
    }
    .circle-loader {
      position: relative;
      width: 100px;
      height: 100px;
      align-self: center;
      margin: 10px 50px;
      .circle {
        height: 100%;
        right: 0px;
        position: absolute;
        border: solid 15px  #a9a9a9 !important;
        border-top-color:  #000 !important;
        border-radius: 50%;
      }

      .border {
        width: 100%;
        transform: rotate(135deg);  
        animation: spin 1.3s steps(2) .2s infinite;
        -webkit-animation: spin 1.3s linear infinite;
      }


      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
    .heading {
      color: #A20202;
      font-size: 26px;
      font-weight: 900;
      display: block;
      text-align: center;
      margin-bottom: 10px;
      /* border-bottom: 1px solid #A20202; */
      /* padding-bottom: 15px; */
      @media (max-width: 767px) {
        font-size: 24px;
      }
      @media (max-width: 380px) {
        margin-top: 10px;
        margin-bottom: 5px;
      }
    }
    /* ------------------------------ BUTTON CLOSE ----------------------------- */
    .btn-close {
      position: absolute;
      top: 20px;
      right: 10px;
      cursor: pointer;
      border: none;
      background-color: transparent;
      transition: all ease 0.25ms;

      display: flex;
      justify-content: flex-end;
      align-items: center;
      svg {
        color: #A20202;
      }
      @media (max-width: 767px) {
        top: 10px;
      }

      &:hover {
        color: #474747;
      }
    }
    /* ------------------------------ BUTTON SOCIAL ----------------------------- */
    .btn-social {
      cursor: pointer;
      transition: background-color ease-in-out 100ms;
      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.08)) drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));
      background-color: #ffffff;
      border-radius: 50px;
      color: #fff;
      border: 0;

      gap: 16px;
      padding: 16px 30px;

      width: 100%;
      max-width: 345px;
      margin: auto;
      height: 48px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      @media (max-width: 767px) {
        padding: 16px;
      }
      p {
        font-weight: 600;
        font-size: 16px;
        line-height: 1.25;
        color: #111;

        span {
          text-transform: capitalize;
        }
        @media (max-width: 767px) {
          font-size: 16px;
        }
      }

      &.icon-google {
        color: #000000;
        background: #ffffff;
        &.disabled {
          background: #e5e5e5;
        }
        &:hover {
          background: #e5e5e5;
          color: #ffffff;
        }
      }
      &.icon-facebook {
        background: #ffffff;
        &.disabled {
          background: #e5e5e5;
        }
        svg {
          color: #337fff;
        }
        &:hover {
          background: #e5e5e5;
        }
      }
      &.icon-line {
        background: #ffffff;
        &.disabled {
          background: #e5e5e5;
        }
        svg {
          color: #3ace01;
        }
        &:hover {
          background: #e5e5e5;
        }
      }
      &.icon-tiktok {
        background: #ffffff;
        &.disabled {
          background: #e5e5e5;
        }
        svg {
          color: #000;
        }
        &:hover {
          background: #e5e5e5;
        }
      }
      &.icon-linkin {
        background: #ffffff;
        &.disabled {
          background: #e5e5e5;
        }
        svg {
          color: #337fff;
        }
        &:hover {
          background: #e5e5e5;
        }
      }
    }
  }
  }
`;
const DisplayLogin = styled.div`
    /* position: fixed; */
    /* top: 35rem; */
    /* z-index: 10; */
    /* right: 30px; */
    a {
      display: flex;
      align-items: center;
      text-decoration: none;
    }
    .info-login {
      display: flex;
      align-items: center;
      color:  rgb(130,137,158);
      font-size: 24px;
    }
      border-radius: 5px 5px 0px 0px;
      background: rgb(130,137,158);
      background: linear-gradient(90deg, rgba(130,137,158,1) 0%, rgba(249,249,255,1) 35%, rgba(249,249,255,1) 54%, rgba(130,134,158,1) 100%);
      /* background: linear-gradient(90deg, rgba(255,209,100,1) 0%,
              rgba(230,187,127,0.92) 37%,rgba(231,189,115,0.7) 43%,
              rgba(231,189,115,0.7) 58%, rgba(230,187,127,0.92) 66%,
              rgba(151,92,3,1) 100%) ; */
      border-radius: 50px;
      /* overflow: hidden; */
      /* width: 320px; */
      object-fit: cover;
      box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
      padding: 3px;
      display: block;
    .bg {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgba(86, 4, 4, 1);
      background: linear-gradient(180deg,rgba(86, 4, 4, 1)  0%,  #000000 100%);
      border-radius: 50px;
      padding: 8px 30px; 
      @media (max-width: 690px) {
              padding: 5px 15px; 
            }
    }

    .picture-login {
      border-radius: 50%;
      /* margin-right: 15px; */
    }
    .text-login {
      display: block;
      color: #fff;
      font-size: 20px;
    }
    .logout {
      cursor: pointer;
      display: flex;
      align-items: center;

      width: 100%;
      background:   rgb(130,137,158);
      border-radius: 50px;
      border: 3px solid  rgb(130,137,158);

    text-align:center;
    padding: 5px 20px; 
    height: 40px;
    margin:auto auto auto 30px;
    transition: 0.75s all;
    /* margin-top: 10px; */
    &:hover {
    background: #000;
    border: 3px solid  rgb(130,137,158);
    }
  }
`;

const BottonSpecial = styled.div`
margin-left: 2rem;
  a {
      display: flex;
      align-items: center;
      color:  rgb(130,137,158);
      font-size: 24px;
      
    }
    .bg {
            padding: 0;
            background: #000000;
            /* padding-top: 30px; */
            opacity: 0.95;
            border-radius: 18px;
            /* padding: 40px 20px; */
            padding: 5px 30px; 
            
            @media (max-width: 690px) {
              padding: 5px 15px; 
            }
          }
    border-radius: 5px 5px 0px 0px;
    background: rgb(130,137,158);
    background: linear-gradient(90deg, rgba(130,137,158,1) 0%, rgba(249,249,255,1) 35%, rgba(249,249,255,1) 54%, rgba(130,134,158,1) 100%);
      /* background: linear-gradient(90deg, rgba(255,209,100,1) 0%,
              rgba(230,187,127,0.92) 37%,rgba(231,189,115,0.7) 43%,
              rgba(231,189,115,0.7) 58%, rgba(230,187,127,0.92) 66%,
              rgba(151,92,3,1) 100%) ; */
      border-radius: 20px;
      height: fit-content;
    padding: 3px;

    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background: transparent; */
    /* padding: 8px; */
    /* border: none; */
    /* border-radius: 50px; */
    &.login {
      /* border: 2px solid rgba(230,187,127,0.92); */
      filter: drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.08)) drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));
    }
    

    svg {
      opacity: ${props => props.check ? 0 : 1};
      width: 20px;
      height: 20px;
      filter: ${props => (props.gray ? 'grayscale(1)' : '')};
      color:  rgb(130,137,158);
      margin-bottom: 0;
      @media (max-width: 1080px) {
        color: #fff;
      }
      @media (max-width: 690px) {
        height: 24px;
        width: 24px;
      }
      @media (max-width: 380px) {
        height: 22px;
        width: 22px;
      }
    }
    .image-user {
      filter: ${props => (props.gray ? 'grayscale(1)' : '')};
      overflow: hidden;
      margin: 0px;
      padding: 0px;
      border-radius: 50%;
      object-fit: cover;
      width: 30px;
      height: 30px;
    }
`;
export default WidgetLogin;
